/**
 * API base URL helpers.
 *
 * REACT_APP_API_URL points at the prefixed API root (e.g. https://api.videxa.ai/api
 * or http://localhost:3050/api). A handful of endpoints — /auth/login,
 * /auth/refresh, /auth/sso/generate — live at the ORIGIN, outside that /api
 * prefix, so callers need the same base with the trailing /api segment removed.
 *
 * Do NOT do this with `url.replace('/api', '')`. String.replace with a string
 * pattern replaces the FIRST occurrence anywhere in the value, and in production
 * the configured value is https://api.videxa.ai — whose authority begins with
 * "//api". The first match lands inside the HOST, not the path:
 *
 *   'https://api.videxa.ai'.replace('/api', '')     -> 'https:/.videxa.ai'
 *   'https://api.videxa.ai/api'.replace('/api', '') -> 'https:/.videxa.ai/api'
 *
 * Both resolve to the host '.videxa.ai', which is not the API, so every auth
 * request fell through to the marketing SPA catch-all and came back as HTML
 * with status 200. The bug is invisible on dev, where the host is
 * dev-api.videxa.ai — a hyphen, not a slash, so nothing matches.
 *
 * The regex below is anchored at end-of-string, so it can only ever strip a
 * trailing path segment and never touches the authority.
 */

/**
 * Strip a trailing `/api` (or `/api/`) path segment from an API base URL.
 * Any other value — including one whose HOST starts with "api." — is returned
 * unchanged.
 *
 * @param {string} url The configured API base URL.
 * @returns {string} The same URL with a trailing /api segment removed.
 */
export const stripApiSuffix = (url) => (url || '').replace(/\/api\/?$/, '');

export default stripApiSuffix;
